
import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import TaskPending from "./TaskPending";
import TaskNotCompleted from "./TaskNotCompleted";
import Export from "../../../src/assests/images/export.svg";
import { Padding } from "@mui/icons-material";
import { dashboardPriority } from "./api";
import { getToken } from "../../utils/utils";


interface User {
  id: number;
  fullName: string;
  outlet_name: string;
  location: string;
  total_points: string;
  redeemed_points: string;
  total_tasks: number;
  last_login_time: string;
  last_login: string;

  task_id: number;

  task_name: string;

  reassign_count: string;

  task_status: string;
}


function PiorityUsers(props: {
  children?: React.ReactNode;
  index: number;
  value: number;
}) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="PiorityUsers"
      hidden={value !== index}
      id={`PiorityUsers-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ padding: "24px 0", boxShadow: "none" }}>
          <Typography sx={{ boxShadow: "none" }}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    "aria-controls": `PiorityUsers-${index}`,
  };
}


export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [isExported, setIsExported] = useState(false);

 console.log(value, "ccccccccccccxxxxxx")

 const handleExportClick = () => {
  setIsExported(true);
  console.log('Export clicked:', true);

  // Reset to false after 2 seconds
  setTimeout(() => {
    setIsExported(false);
    console.log('Reset to false');
  }, 2000);
};

 const [dropdownValue, setDropdownValue] = useState("");
 const [dropdownValue1, setDropdownValue1] = useState("");
   const [users, setUsers] = useState<User[]>([]);

 const fetchDashboardApi = async () => {
     try {
       const reqBody = {
        task_not_completed: value === 0 ? true : false,
        task_pending: value === 1 ? true : false,
        isexport:isExported,
        filters:{
          location:dropdownValue?dropdownValue:null,
          task_name:dropdownValue1?dropdownValue1:null
      }
       };
 
       const res = await dashboardPriority(reqBody, getToken());
 
       if (Array.isArray(res?.data.data)) {
         setUsers(res.data.data);
 
       } else {
         setUsers([]);
       }
     } catch (error) {
       console.error("Error fetching data:", error);
       setUsers([]);
     }
   };
 
 
   useEffect(() => {
     fetchDashboardApi();
   }, [value, dropdownValue,dropdownValue1,isExported]);




console.log(isExported, "isExportedisExportedisExported")
  return (
    <Box
      sx={{
        width: "100%",
        background: "#fff",
        padding: "20px",
        margin: "0 30px",
        boxShadow: "none",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "18px", color: "#282829" }}
        >
          Priority Users
        </Typography>
        <Typography>
      <img 
        width="20px" 
        src={Export} 
        alt="export" 
        onClick={handleExportClick} 
        style={{ cursor: 'pointer' }}
      />
    </Typography>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            "& .MuiTabs-flexContainer": {
              display: "flex",
              justifyContent: "space-between",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#c8172f",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              color: "#7D7E7F",
              fontSize: "16px",
              fontWeight: "300",
              padding: "0",
            },
            "& .Mui-selected": {
              color: "#c8172f !important",
            },
          }}
        >
          <Tab label="Last 2 task Not Completed" {...a11yProps(0)} />
          <Tab label="Task Pending (2 days left)" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <PiorityUsers value={value} index={0}>
        <TaskNotCompleted  users ={users}/>
      </PiorityUsers>
      <PiorityUsers value={value} index={1}>
        <TaskPending   
        dropdownValue={dropdownValue}
        setDropdownValue={setDropdownValue}
        dropdownValue1={dropdownValue1}
        setDropdownValue1={setDropdownValue1}
        users={users} setUsers={setUsers}
         />
      </PiorityUsers>
    </Box>
  );
}
